export const ADD_PAGE_FILTERS = 'REPORTING_ADD_PAGE_FILTERS';

export const FILTER_TYPES = {
  THEMATIC: 'thematic',
  NORMAL: 'normal',
};

export const addPageFilters = (filterType, filterValues) => ({
  type: ADD_PAGE_FILTERS,
  filterType,
  filterValues,
});
